package com.shadowings.gero.presentation.component.quiz

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedCard
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.toUpperCase
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.navigation.NavController
import androidx.navigation.compose.rememberNavController
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.LessonIds
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.presentation.component.GeroButton
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.ui.hieroglyphTint
import com.shadowings.gero.presentation.util.DeviceClass
import com.shadowings.gero.presentation.util.DevicePreviews
import com.shadowings.gero.presentation.util.rememberDeviceInfo
import com.shadowings.gero.util.SoundPlayer
import com.shadowings.gero.util.currentDateAsInt
import com.shadowings.gero.util.isConsecutiveDay
import com.shadowings.gero.util.systemLanguageCode
import gero.composeapp.generated.resources.A12
import gero.composeapp.generated.resources.A19
import gero.composeapp.generated.resources.A8
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.final_quiz_alyn_perfect_feedback_1
import gero.composeapp.generated.resources.final_quiz_alyn_perfect_feedback_2
import gero.composeapp.generated.resources.final_quiz_alyn_stars0_feedback_1
import gero.composeapp.generated.resources.final_quiz_alyn_stars0_feedback_2
import gero.composeapp.generated.resources.final_quiz_alyn_stars1_feedback_1
import gero.composeapp.generated.resources.final_quiz_alyn_stars1_feedback_2
import gero.composeapp.generated.resources.final_quiz_alyn_stars2_feedback_1
import gero.composeapp.generated.resources.final_quiz_alyn_stars2_feedback_2
import gero.composeapp.generated.resources.final_quiz_alyn_stars3_feedback_1
import gero.composeapp.generated.resources.final_quiz_alyn_stars3_feedback_2
import gero.composeapp.generated.resources.final_quiz_corrected_many
import gero.composeapp.generated.resources.final_quiz_corrected_none
import gero.composeapp.generated.resources.final_quiz_corrected_one
import gero.composeapp.generated.resources.final_quiz_label_accuracy
import gero.composeapp.generated.resources.final_quiz_label_exp
import gero.composeapp.generated.resources.final_quiz_label_time
import gero.composeapp.generated.resources.final_quiz_masko_perfect_feedback_1
import gero.composeapp.generated.resources.final_quiz_masko_perfect_feedback_2
import gero.composeapp.generated.resources.final_quiz_masko_stars0_feedback_1
import gero.composeapp.generated.resources.final_quiz_masko_stars0_feedback_2
import gero.composeapp.generated.resources.final_quiz_masko_stars1_feedback_1
import gero.composeapp.generated.resources.final_quiz_masko_stars1_feedback_2
import gero.composeapp.generated.resources.final_quiz_masko_stars2_feedback_1
import gero.composeapp.generated.resources.final_quiz_masko_stars2_feedback_2
import gero.composeapp.generated.resources.final_quiz_masko_stars3_feedback_1
import gero.composeapp.generated.resources.final_quiz_masko_stars3_feedback_2
import gero.composeapp.generated.resources.final_quiz_nilo_perfect_feedback_1
import gero.composeapp.generated.resources.final_quiz_nilo_perfect_feedback_2
import gero.composeapp.generated.resources.final_quiz_nilo_stars0_feedback_1
import gero.composeapp.generated.resources.final_quiz_nilo_stars0_feedback_2
import gero.composeapp.generated.resources.final_quiz_nilo_stars1_feedback_1
import gero.composeapp.generated.resources.final_quiz_nilo_stars1_feedback_2
import gero.composeapp.generated.resources.final_quiz_nilo_stars2_feedback_1
import gero.composeapp.generated.resources.final_quiz_nilo_stars2_feedback_2
import gero.composeapp.generated.resources.final_quiz_nilo_stars3_feedback_1
import gero.composeapp.generated.resources.final_quiz_nilo_stars3_feedback_2
import gero.composeapp.generated.resources.final_quiz_zeta_perfect_feedback_1
import gero.composeapp.generated.resources.final_quiz_zeta_perfect_feedback_2
import gero.composeapp.generated.resources.final_quiz_zeta_stars0_feedback_1
import gero.composeapp.generated.resources.final_quiz_zeta_stars0_feedback_2
import gero.composeapp.generated.resources.final_quiz_zeta_stars1_feedback_1
import gero.composeapp.generated.resources.final_quiz_zeta_stars1_feedback_2
import gero.composeapp.generated.resources.final_quiz_zeta_stars2_feedback_1
import gero.composeapp.generated.resources.final_quiz_zeta_stars2_feedback_2
import gero.composeapp.generated.resources.final_quiz_zeta_stars3_feedback_1
import gero.composeapp.generated.resources.final_quiz_zeta_stars3_feedback_2
import gero.composeapp.generated.resources.fine_btn
import gero.composeapp.generated.resources.quiz_completed_title
import gero.composeapp.generated.resources.stella
import gero.composeapp.generated.resources.stella_full
import gero.composeapp.generated.resources.stella_perfetta
import io.github.vinceglb.confettikit.compose.ConfettiKit
import io.github.vinceglb.confettikit.core.Party
import io.github.vinceglb.confettikit.core.Position
import io.github.vinceglb.confettikit.core.emitter.Emitter
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import kotlin.math.roundToInt
import kotlin.time.DurationUnit
import kotlin.time.TimeMark
import kotlin.time.TimeSource
import kotlin.time.toDuration

@DevicePreviews
@Preview(name = "FinalQuiz - tutte sbagliate")
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun FinalQuizScreenAllWrongPreview() {
    AppTheme {
        Surface {
            FinalQuizScreenComposable(
                quizResults = mutableStateOf(
                    mapOf("a" to false, "b" to false, "c" to false)
                ),
                isPerfect = false,
                navController = rememberNavController(),
                onQuizCompleted = { _, _, _ -> }
            )
        }
    }
}

@DevicePreviews
@Preview(name = "FinalQuiz - 0 errori (PERFECT)")
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun FinalQuizScreenZeroErrorsPerfectPreview() {
    AppTheme {
        Surface {
            FinalQuizScreenComposable(
                quizResults = mutableStateOf(
                    mapOf("a" to true, "b" to true, "c" to true)
                ),
                isPerfect = true,
                navController = rememberNavController(),
                onQuizCompleted = { _, _, _ -> }
            )
        }
    }
}

@DevicePreviews
@Preview(name = "FinalQuiz - 0 errori (3 stelle non perfect)")
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun FinalQuizScreenZeroErrorsNotPerfectPreview() {
    AppTheme {
        Surface {
            FinalQuizScreenComposable(
                quizResults = mutableStateOf(
                    mapOf("a" to true, "b" to true, "c" to true)
                ),
                isPerfect = false,
                navController = rememberNavController(),
                onQuizCompleted = { _, _, _ -> }
            )
        }
    }
}

@DevicePreviews
@Preview(name = "FinalQuiz - 1 errore")
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun FinalQuizScreenOneErrorPreview() {
    val mark = TimeSource.Monotonic.markNow() - 73_000.toDuration(DurationUnit.MILLISECONDS)
    AppTheme {
        Surface {
            FinalQuizScreenComposable(
                quizResults = mutableStateOf(
                    mapOf("a" to true, "b" to true, "c" to false)
                ),
                isPerfect = false,
                quizStartMark = mark,
                comboFiveRewards = 1,
                navController = rememberNavController(),
                onQuizCompleted = { _, _, _ -> }
            )
        }
    }
}

@DevicePreviews
@Preview(name = "FinalQuiz - 2 errori")
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun FinalQuizScreenTwoErrorsPreview() {
    AppTheme {
        Surface {
            FinalQuizScreenComposable(
                quizResults = mutableStateOf(
                    mapOf("a" to true, "b" to false, "c" to false)
                ),
                isPerfect = false,
                navController = rememberNavController(),
                onQuizCompleted = { _, _, _ -> }
            )
        }
    }
}

@DevicePreviews
@Preview(name = "FinalQuiz - 3 errori")
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun FinalQuizScreenThreeErrorsPreview() {
    AppTheme {
        Surface {
            FinalQuizScreenComposable(
                quizResults = mutableStateOf(
                    mapOf("a" to false, "b" to false, "c" to false)
                ),
                isPerfect = false,
                navController = rememberNavController(),
                onQuizCompleted = { _, _, _ -> }
            )
        }
    }
}

@DevicePreviews
@Preview(heightDp = 717, widthDp = 360)
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun FinalQuizScreenComposablePreview() {
    AppTheme {
        Surface {
            FinalQuizScreenComposable(
                quizResults = mutableStateOf(
                    mapOf("a" to true, "b" to true, "c" to false, "d" to true, "e" to true)
                ),
                isPerfect = false,
                navController = rememberNavController(),
                onQuizCompleted = { _, _, _ -> }
            )
        }
    }
}

@Preview(heightDp = 717, widthDp = 360)
@Composable
private fun FinalQuizScreenCorrectionPreview() {
    AppTheme {
        Surface {
            FinalQuizScreenComposable(
                quizResults = mutableStateOf(
                    mapOf("a" to true, "b" to true, "c" to false, "d" to true)
                ),
                isPerfect = false,
                isCorrection = true,
                availableCharacters = listOf(Characters.Alyn),
                navController = rememberNavController(),
                onQuizCompleted = { _, _, _ -> }
            )
        }
    }
}

@Composable
private fun correctedMistakesText(correctedCount: Int): String = when (correctedCount) {
    0 -> stringResource(Res.string.final_quiz_corrected_none)
    1 -> stringResource(Res.string.final_quiz_corrected_one)
    else -> stringResource(Res.string.final_quiz_corrected_many, correctedCount)
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun FinalQuizScreenComposable(
    quizResults: MutableState<Map<String, Boolean>>,
    isPerfect: Boolean,
    // Correction drill (LessonIds.CORRECTION): no stars are awarded, so the stars row is hidden
    // and the character (always Alyn, see QuizViewModel) says "N mistakes corrected" instead of
    // the usual stars-based feedback line.
    isCorrection: Boolean = false,
    availableCharacters: List<Characters> = listOf(Characters.Alyn, Characters.Nilo),
    quizStartMark: TimeMark? = null,
    comboFiveRewards: Int = 0,
    navController: NavController,
    userData: UserData = UserData(),
    isVisible: Boolean = true,
    onQuizCompleted: (stars: Int, total: Int, errors: Int) -> Unit,
    onContinue: () -> Unit = { navController.popBackStack() }
) {
    val correct = quizResults.value.values.count { it }
    val total = quizResults.value.size
    val errors = quizResults.value.values.count { !it }
    val stars = (3 - errors).coerceIn(0, 3)

    // "Fine" must act once: a double tap completed the quiz twice and popped the back stack twice,
    // closing the Landing screen behind the quiz too. Not disabling the button, so it doesn't
    // flash a disabled style during the exit transition.
    val finished = remember { mutableStateOf(false) }
    val finishOnce: () -> Unit = {
        if (!finished.value) {
            finished.value = true
            onQuizCompleted(stars, total, errors)
            onContinue()
        }
    }

    val isFirstOfToday = userData.lastQuizDate != currentDateAsInt()

    val today = currentDateAsInt()
    val consecutive = isConsecutiveDay(userData.lastQuizDate, today)
    val newStrike = if (consecutive) userData.strike + 1 else 1

    val earnedXp = correct + comboFiveRewards
    val totalXp = earnedXp + (if (isFirstOfToday) 10 else 0)

    // Tempo: mm:ss
    val startMark = quizStartMark ?: TimeSource.Monotonic.markNow()
    val elapsed = startMark.elapsedNow()
    val elapsedSec = elapsed.inWholeSeconds.toInt().coerceAtLeast(0)
    val mm = elapsedSec / 60
    val ss = elapsedSec % 60
    val elapsedText = mm.toString().padStart(2, '0') + ":" + ss.toString().padStart(2, '0')

    // Percentuale risposte corrette
    val percentCorrect =
        if (total > 0) ((correct.toFloat() / total.toFloat()) * 100f).roundToInt() else 0

    // Mostriamo i soli solo se il quiz  in stato PERFECT (persistito nello userData).
    val showSuns = isPerfect

    val expLabel = stringResource(Res.string.final_quiz_label_exp)
    val timeLabel = stringResource(Res.string.final_quiz_label_time)
    val accuracyLabel = stringResource(Res.string.final_quiz_label_accuracy)

    // Picked once per quiz completion, not re-picked on every recomposition (e.g. when
    // showConfetti flips after LaunchedEffect below).
    val character = remember(availableCharacters) { availableCharacters.random() }
    val feedbackFace = remember(stars, showSuns) {
        finalQuizFeedbackFace(stars, showSuns)
    }
    val feedbackOptions = finalQuizFeedbackOptions(character, stars, showSuns)
    val correctedText = correctedMistakesText(correct)
    val feedbackText = if (isCorrection) {
        correctedText
    } else {
        remember(feedbackOptions) { feedbackOptions.random() }
    }

    // Nilo doesn't start talking until the player has learned to read transliterations.
    val hasNiloLearnedToTalk = userData.explanations.contains(LessonIds.TRANSLITERATION_READING)
    val languageCode = userData.language.ifBlank { systemLanguageCode() }
    val displayedFeedbackText =
        remember(character, feedbackText, hasNiloLearnedToTalk, languageCode) {
            if (character == Characters.Nilo && !hasNiloLearnedToTalk) {
                babbleAsNilo(feedbackText, languageCode)
            } else {
                feedbackText
            }
        }

    val deviceInfo = rememberDeviceInfo()
    val showConfetti = remember { mutableStateOf(false) }
    LaunchedEffect(isVisible) {
        if (isVisible) {
            showConfetti.value = true
            SoundPlayer.playFinalStars(stars)
        }
    }

    Box(modifier = Modifier.fillMaxSize()) {
        if (deviceInfo.isLandscape) {
            Row(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(horizontal = 24.dp, vertical = 16.dp),
                horizontalArrangement = Arrangement.spacedBy(24.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                // Column 1: Title, Avatar Feedback, Nilo Feedback (if any), Stars
                Column(
                    modifier = Modifier.weight(1.2f),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(8.dp)
                ) {
                    Text(
                        text = stringResource(Res.string.quiz_completed_title),
                        style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold),
                        textAlign = TextAlign.Center,
                        modifier = Modifier.fillMaxWidth()
                            .semantics { testTag = "final_quiz_title" }
                    )

                    Box(
                        modifier = Modifier,
                        contentAlignment = Alignment.Center
                    ) {
                        FeedbackBox(
                            character = character,
                            face = feedbackFace,
                            text = displayedFeedbackText,
                            userData = userData,
                            isLandscape = true,
                            useFullText = true
                        )
                    }

                    // ── Stelle / Soli (nascoste nella correzione errori) ──
                    if (!isCorrection) {
                        Row(
                            horizontalArrangement = Arrangement.Center,
                            modifier = Modifier.fillMaxWidth()
                                .semantics { testTag = "final_quiz_stars_row" }
                        ) {
                            for (i in 1..3) {
                                Image(
                                    modifier = Modifier.size(36.dp)
                                        .semantics { testTag = "final_quiz_star_$i" },
                                    painter = when {
                                        showSuns -> painterResource(Res.drawable.stella_perfetta)
                                        i <= stars -> painterResource(Res.drawable.stella_full)
                                        else -> painterResource(Res.drawable.stella)
                                    },
                                    contentDescription = null,
                                    colorFilter = ColorFilter.tint(
                                        MaterialTheme.colorScheme.onSurface
                                    )
                                )
                                if (i < 3) Spacer(Modifier.width(8.dp))
                            }
                        }
                    }
                }

                // Column 2: Stats and Button
                Column(
                    modifier = Modifier.weight(1f),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    val fontScale = LocalDensity.current.fontScale
                    if (fontScale < 1.49f) {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .semantics { testTag = "final_quiz_stats_row" },
                            horizontalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            StatCard(
                                modifier = Modifier.weight(1f),
                                res = Res.drawable.A8,
                                value = "+$totalXp",
                                label = expLabel,
                                isLandscape = true
                            )
                            StatCard(
                                modifier = Modifier.weight(1f),
                                res = Res.drawable.A19,
                                value = elapsedText,
                                label = timeLabel,
                                isLandscape = true
                            )
                            StatCard(
                                modifier = Modifier.weight(1f),
                                res = Res.drawable.A12,
                                value = "$percentCorrect%",
                                label = accuracyLabel,
                                isLandscape = true
                            )
                        }
                    } else {
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .semantics { testTag = "final_quiz_stats_row" },
                            verticalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            StatCard(
                                modifier = Modifier.fillMaxWidth(),
                                res = Res.drawable.A8,
                                value = "+$totalXp",
                                label = expLabel,
                                isLandscape = true
                            )
                            StatCard(
                                modifier = Modifier.fillMaxWidth(),
                                res = Res.drawable.A19,
                                value = elapsedText,
                                label = timeLabel,
                                isLandscape = true
                            )
                            StatCard(
                                modifier = Modifier.fillMaxWidth(),
                                res = Res.drawable.A12,
                                value = "$percentCorrect%",
                                label = accuracyLabel,
                                isLandscape = true
                            )
                        }
                    }

                    GeroButton(
                        title = stringResource(Res.string.fine_btn),
                        testTagId = "final_quiz_btn_end",
                        modifier = Modifier.fillMaxWidth().height(64.dp).padding(horizontal = 8.dp)
                    ) {
                        finishOnce()
                    }
                }
            }
        } else {
            Column(
                Modifier.fillMaxSize()
            ) {
                Text(
                    text = stringResource(Res.string.quiz_completed_title),
                    style = MaterialTheme.typography.displaySmall.copy(fontWeight = FontWeight.Bold),
                    textAlign = TextAlign.Center,
                    modifier = Modifier.fillMaxWidth()
                        .padding(top = 16.dp)
                        .semantics { testTag = "final_quiz_title" }
                )

                val padding = when (deviceInfo.deviceClass) {
                    DeviceClass.PHONE_SMALL -> 4.dp
                    DeviceClass.PHONE_MEDIUM -> 8.dp
                    else -> 16.dp
                }

                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(horizontal = 24.dp, vertical = padding),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.SpaceEvenly
                ) {
                    Column(horizontalAlignment = Alignment.CenterHorizontally) {
                        Spacer(Modifier.height(8.dp))
                        FeedbackBox(
                            character = character,
                            face = feedbackFace,
                            text = displayedFeedbackText,
                            userData = userData,
                            useFullText = true
                        )
                    }
                    val starSize = when (deviceInfo.deviceClass) {
                        DeviceClass.PHONE_SMALL -> 36.dp
                        DeviceClass.PHONE_MEDIUM -> 48.dp
                        else -> 56.dp
                    }

                    // ── Stelle / Soli (nascoste nella correzione errori) ──
                    if (!isCorrection) {
                        Row(
                            horizontalArrangement = Arrangement.Center,
                            modifier = Modifier.fillMaxWidth()
                                .semantics { testTag = "final_quiz_stars_row" }
                        ) {
                            for (i in 1..3) {
                                Image(
                                    modifier = Modifier.size(starSize)
                                        .semantics { testTag = "final_quiz_star_$i" },
                                    painter = when {
                                        showSuns -> painterResource(Res.drawable.stella_perfetta)
                                        i <= stars -> painterResource(Res.drawable.stella_full)
                                        else -> painterResource(Res.drawable.stella)
                                    },
                                    contentDescription = null,
                                    colorFilter = ColorFilter.tint(
                                        MaterialTheme.colorScheme.onSurface
                                    )
                                )
                                if (i < 3) Spacer(Modifier.width(8.dp))
                            }
                        }
                    }

                    // ── Statistiche ──
                    Spacer(Modifier.height(8.dp))
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .semantics { testTag = "final_quiz_stats_row" },
                        horizontalArrangement = Arrangement.spacedBy(12.dp)
                    ) {
                        StatCard(
                            modifier = Modifier.weight(1f),
                            res = Res.drawable.A8,
                            label = expLabel,
                            value = "+$totalXp"
                        )
                        StatCard(
                            modifier = Modifier.weight(1f),
                            res = Res.drawable.A19,
                            label = timeLabel,
                            value = elapsedText
                        )
                        StatCard(
                            modifier = Modifier.weight(1f),
                            res = Res.drawable.A12,
                            label = accuracyLabel,
                            value = "$percentCorrect%"
                        )
                    }
                    Spacer(Modifier.height(8.dp))
                    // ── Bottone fine ──
                    GeroButton(
                        modifier = Modifier.height(64.dp).fillMaxWidth(),
                        title = stringResource(Res.string.fine_btn),
                        testTagId = "final_quiz_btn_end"
                    ) {
                        finishOnce()
                    }
                }
            }
        }

        if (stars == 3 && showConfetti.value) {
            ConfettiKit(
                modifier = Modifier.fillMaxSize(),
                parties = listOf(
                    Party(
                        speed = 0f, maxSpeed = 30f, damping = 0.9f, spread = 360,
                        position = Position.Relative(0.5, 0.2),
                        emitter = Emitter(duration = 3L.toDuration(DurationUnit.SECONDS)).max(150)
                    )
                )
            )
        }
    }
}


@Composable
private fun StatCard(
    modifier: Modifier = Modifier,
    res: DrawableResource,
    value: String,
    label: String,
    isLandscape: Boolean = false
) {
    val fontScale = LocalDensity.current.fontScale


    OutlinedCard(
        modifier = modifier,
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.tertiaryContainer
        )
    ) {
        if (fontScale > 1.49f && isLandscape) {
            Row(
                modifier = Modifier.fillMaxWidth().padding(if (isLandscape) 6.dp else 12.dp),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(
                    modifier = Modifier.height(if (isLandscape || fontScale > 1.49f) 24.dp else 32.dp),
                    painter = painterResource(res),
                    contentDescription = null,
                    colorFilter = ColorFilter.tint(hieroglyphTint)
                )
                Spacer(Modifier.width(16.dp))
                Text(
                    text = value,
                    style = (if (isLandscape) MaterialTheme.typography.bodyMedium else MaterialTheme.typography.bodyLarge).copy(
                        fontWeight = FontWeight.Bold
                    ),
                    color = MaterialTheme.colorScheme.onTertiaryContainer,
                    maxLines = 1,
                    textAlign = TextAlign.Center,
                    overflow = androidx.compose.ui.text.style.TextOverflow.Ellipsis,
                )
                Spacer(Modifier.width(8.dp))
                Text(
                    text = label.toUpperCase(Locale.current),
                    style = (if (isLandscape) MaterialTheme.typography.bodySmall else MaterialTheme.typography.bodyMedium),
                    color = MaterialTheme.colorScheme.onTertiaryContainer,
                    maxLines = 1,
                    textAlign = TextAlign.Center,
                    overflow = androidx.compose.ui.text.style.TextOverflow.Ellipsis,
                )
            }
        } else {
            Column(
                modifier = Modifier.fillMaxWidth().padding(if (isLandscape) 6.dp else 12.dp),
                verticalArrangement = Arrangement.SpaceBetween,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Image(
                    modifier = Modifier.height(if (isLandscape || fontScale > 1.49f) 24.dp else 32.dp),
                    painter = painterResource(res),
                    contentDescription = null,
                    colorFilter = ColorFilter.tint(hieroglyphTint)
                )
                Text(
                    text = value,
                    style = (if (isLandscape) MaterialTheme.typography.bodyMedium else MaterialTheme.typography.bodyLarge).copy(
                        fontWeight = FontWeight.Bold
                    ),
                    color = MaterialTheme.colorScheme.onTertiaryContainer,
                    maxLines = 1,
                    textAlign = TextAlign.Center,
                    overflow = androidx.compose.ui.text.style.TextOverflow.Ellipsis,
                )
                Text(
                    text = label.toUpperCase(Locale.current),
                    style = (if (isLandscape) MaterialTheme.typography.bodySmall else MaterialTheme.typography.bodyMedium),
                    color = MaterialTheme.colorScheme.onTertiaryContainer,
                    maxLines = 1,
                    textAlign = TextAlign.Center,
                    overflow = androidx.compose.ui.text.style.TextOverflow.Ellipsis,
                )
            }
        }
    }
}

// Character-agnostic: each avatar composable falls back to its own default look for any face
// it doesn't render a distinct expression for, so this doesn't need to special-case characters.
private fun finalQuizFeedbackFace(stars: Int, isPerfect: Boolean): Faces {
    return when {
        isPerfect -> Faces.Perfect
        stars >= 2 -> Faces.Happy
        else -> Faces.Sad
    }
}

@Composable
private fun finalQuizFeedbackOptions(
    character: Characters,
    stars: Int,
    isPerfect: Boolean
): List<String> {
    return when (character) {
        Characters.Alyn -> when {
            isPerfect -> listOf(
                stringResource(Res.string.final_quiz_alyn_perfect_feedback_1),
                stringResource(Res.string.final_quiz_alyn_perfect_feedback_2)
            )

            stars == 3 -> listOf(
                stringResource(Res.string.final_quiz_alyn_stars3_feedback_1),
                stringResource(Res.string.final_quiz_alyn_stars3_feedback_2)
            )

            stars == 2 -> listOf(
                stringResource(Res.string.final_quiz_alyn_stars2_feedback_1),
                stringResource(Res.string.final_quiz_alyn_stars2_feedback_2)
            )

            stars == 1 -> listOf(
                stringResource(Res.string.final_quiz_alyn_stars1_feedback_1),
                stringResource(Res.string.final_quiz_alyn_stars1_feedback_2)
            )

            else -> listOf(
                stringResource(Res.string.final_quiz_alyn_stars0_feedback_1),
                stringResource(Res.string.final_quiz_alyn_stars0_feedback_2)
            )
        }

        Characters.Nilo -> when {
            isPerfect -> listOf(
                stringResource(Res.string.final_quiz_nilo_perfect_feedback_1),
                stringResource(Res.string.final_quiz_nilo_perfect_feedback_2)
            )

            stars == 3 -> listOf(
                stringResource(Res.string.final_quiz_nilo_stars3_feedback_1),
                stringResource(Res.string.final_quiz_nilo_stars3_feedback_2)
            )

            stars == 2 -> listOf(
                stringResource(Res.string.final_quiz_nilo_stars2_feedback_1),
                stringResource(Res.string.final_quiz_nilo_stars2_feedback_2)
            )

            stars == 1 -> listOf(
                stringResource(Res.string.final_quiz_nilo_stars1_feedback_1),
                stringResource(Res.string.final_quiz_nilo_stars1_feedback_2)
            )

            else -> listOf(
                stringResource(Res.string.final_quiz_nilo_stars0_feedback_1),
                stringResource(Res.string.final_quiz_nilo_stars0_feedback_2)
            )
        }

        Characters.Zeta -> when {
            isPerfect -> listOf(
                stringResource(Res.string.final_quiz_zeta_perfect_feedback_1),
                stringResource(Res.string.final_quiz_zeta_perfect_feedback_2)
            )

            stars == 3 -> listOf(
                stringResource(Res.string.final_quiz_zeta_stars3_feedback_1),
                stringResource(Res.string.final_quiz_zeta_stars3_feedback_2)
            )

            stars == 2 -> listOf(
                stringResource(Res.string.final_quiz_zeta_stars2_feedback_1),
                stringResource(Res.string.final_quiz_zeta_stars2_feedback_2)
            )

            stars == 1 -> listOf(
                stringResource(Res.string.final_quiz_zeta_stars1_feedback_1),
                stringResource(Res.string.final_quiz_zeta_stars1_feedback_2)
            )

            else -> listOf(
                stringResource(Res.string.final_quiz_zeta_stars0_feedback_1),
                stringResource(Res.string.final_quiz_zeta_stars0_feedback_2)
            )
        }

        Characters.Masko -> when {
            isPerfect -> listOf(
                stringResource(Res.string.final_quiz_masko_perfect_feedback_1),
                stringResource(Res.string.final_quiz_masko_perfect_feedback_2)
            )

            stars == 3 -> listOf(
                stringResource(Res.string.final_quiz_masko_stars3_feedback_1),
                stringResource(Res.string.final_quiz_masko_stars3_feedback_2)
            )

            stars == 2 -> listOf(
                stringResource(Res.string.final_quiz_masko_stars2_feedback_1),
                stringResource(Res.string.final_quiz_masko_stars2_feedback_2)
            )

            stars == 1 -> listOf(
                stringResource(Res.string.final_quiz_masko_stars1_feedback_1),
                stringResource(Res.string.final_quiz_masko_stars1_feedback_2)
            )

            else -> listOf(
                stringResource(Res.string.final_quiz_masko_stars0_feedback_1),
                stringResource(Res.string.final_quiz_masko_stars0_feedback_2)
            )
        }
    }
}

// Before the player learns to read transliterations, Nilo can't form real words yet: every
// word in the picked sentence becomes the localized meow, punctuation and spacing untouched.
private fun babbleAsNilo(text: String, languageCode: String): String {
    val meow = localizedMeowWord(languageCode)
    val meowLower = meow.lowercase()
    return Regex("\\p{L}+").replace(text) { match ->
        if (match.value.first().isUpperCase()) meow else meowLower
    }
}
